export default __webpack_public_path__ + "static/media/coin98.339be55c.svg";